import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  Output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Editor, NgxEditorModule, Toolbar } from 'ngx-editor';

@Component({
  selector: 'app-ngx-editor',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxEditorModule,
    TranslateModule,
  ],
  templateUrl: './app-ngx-editor.component.html',
  styles: `
  ::ng-deep{
    .NgxEditor{
      ul{
        list-style: initial !important;
        padding-right:2rem !important;
        padding-left:2rem !important;
      }
      ol{
        list-style: auto !important;
        padding-right:2rem !important;
        padding-left:2rem !important;
      }
    }
  }

  `,
})
export class AppNgxEditorComponent {
  @Input() control: FormControl | any; // Initial value for edit mode
  @Input() placeHolder: string = '';
  @Input() html = '';
  elementRef = inject(ElementRef);
  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  isFullScreen: boolean = false;
  @HostBinding('class') class = 'tw-relative';
  @Output() contentChanged = new EventEmitter<string>();

  ngOnInit(): void {
    this.editor = new Editor();
    if (!this.html) this.html = (this.control as FormControl).value || '';
    this.editor.commands.insertHTML(this.html).focus().scrollIntoView().exec();
  }

  ngAfterViewInit(): void {
    //added css class
    const el: HTMLElement = this.elementRef.nativeElement as HTMLElement;
    el.querySelector('.NgxEditor__Content').className =
      'NgxEditor__Content !tw-min-h-[200px] dark:tw-text-gray-200';
    el.querySelector('.NgxEditor__MenuBar')?.classList?.add(
      '!tw-bg-transparent'
    );
    el.querySelector('.NgxEditor__MenuBar')?.classList?.add(
      'dark:tw-text-gray-100'
    );
    const ngxEditorElement = el.querySelector('.NgxEditor');
    ngxEditorElement?.classList?.add('dark:!tw-bg-transparent');
    ngxEditorElement?.classList?.add('dark:!tw-border-[#74747d]');
    ngxEditorElement?.classList?.add('!tw-border-[#9e9e9e]');
  }

  toggleFullScreen() {
    this.isFullScreen = !this.isFullScreen;
    (this.elementRef.nativeElement as HTMLElement)
      .querySelector('.NgxEditor__Content')
      ?.classList.toggle('tw-h-screen');
  }

  onContentChange(event) {
    this.contentChanged.emit(event);
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
